function getAppCulture() {
    if (typeof kendo !== 'undefined' && kendo.culture) {
        let c = kendo.culture();
        if (c && c.name) return c.name;
    }
    return undefined;
}

export function formatNumber(value, options) {
    if (value == null || value === '') return '';
    let num = Number(value);
    if (isNaN(num)) return String(value);

    let opts = options || {};
    let config = {};
    if (opts.decimals != null) {
        config.minimumFractionDigits = opts.decimals;
        config.maximumFractionDigits = opts.decimals;
    }
    if (opts.useGrouping === false) config.useGrouping = false;
    return num.toLocaleString(getAppCulture(), config);
}

export function formatPercent(value, total, options) {
    if (!total) return '0%';
    let decimals = options && options.decimals != null ? options.decimals : 1;
    let pct = (Number(value) / Number(total)) * 100;
    return formatNumber(pct, { decimals }) + '%';
}

export function formatDate(value, options) {
    if (value == null || value === '') return '';
    let d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) return String(value);
    let opts = options || {};
    let config = opts.includeTime
        ? { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }
        : { year: 'numeric', month: '2-digit', day: '2-digit' };
    return d.toLocaleString(getAppCulture(), config);
}

export function formatByKind(value, kind, options) {
    if (value == null || value === '') return '';
    switch (kind) {
        case 'number':  return formatNumber(value, options);
        case 'percent': return formatNumber(value, options) + '%';
        case 'date':    return formatDate(value, options);
        case 'text':    return String(value);
        default:        return typeof value === 'number' ? formatNumber(value, options) : String(value);
    }
}

export function getFkText(feature, fieldName) {
    let direct = feature.get(fieldName + '_fktext');
    if (direct != null) return String(direct);

    let props = feature.getProperties();
    let target = (fieldName + '_fktext').toLowerCase();
    for (let key in props) {
        if (key.toLowerCase() === target && props[key] != null) {
            return String(props[key]);
        }
    }
    return null;
}
